/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PraticaAllegatoDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DownloadPraticaAllegatoCittadinoRequestParams {
    id: string;
    idAllegato: string;
}

export interface ListPraticaAllegatiCittadinoRequestParams {
    id: string;
}


export interface CittadinoAllegatiPraticaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Download del binario di un allegato della propria pratica. Content-Disposition: attachment; filename&#x3D;\&quot;&lt;nome_file_originale&gt;\&quot;.
     * 
     * @endpoint get /api/v1/cittadino/pratiche/{id}/allegati/{idAllegato}
* @param requestParameters
     */
    downloadPraticaAllegatoCittadino(requestParameters: DownloadPraticaAllegatoCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Lista degli allegati della propria pratica (cross-origine: cittadino + operatore + sistema). Cross-user → 404 privacy-preserving.
     * 
     * @endpoint get /api/v1/cittadino/pratiche/{id}/allegati
* @param requestParameters
     */
    listPraticaAllegatiCittadino(requestParameters: ListPraticaAllegatiCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Array<PraticaAllegatoDTO>>;

}
